import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { type OpalApiResponseDocument } from '../../schema'

export type ReadLabelV2ResponseData = OpalApiResponseDocument<
  'ReadLabelsV2',
  200
>

type LabelReadParams = {
  include?: 'label_set'[]
  page?: {
    offset?: number
    limit?: number
  }
  filter?: {
    brand_id?: number
    is_active?: boolean
    label_set_id?: number
  }
}

export const readLabels = async (params: LabelReadParams) => {
  const url = new URL('/labels/v2', window.location.origin)
  url.search = queryString(params)

  return HttpClient()
    .get<ReadLabelV2ResponseData>(url.toString())
    .then((res) => res.data)
}
